module.exports = __webpack_public_path__ + "static/pohjalainenyrittaja2.7e19b197.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pohjalainenyrittaja2.jpg
// module id = 838
// module chunks = 129563053867776